/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2024 Glowing Blue AG.
 * Authors: Davide Iadeluca.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';

export default class GlobalStats extends Model {
	users() {
		return Model.attribute<number>('users').call(this);
	}

	discussions() {
		return Model.attribute<number>('discussions').call(this);
	}

	currentlyOnline() {
		return Model.attribute<number>('currentlyOnline').call(this);
	}

	apiEndpoint() {
		return '/gamilytics/globalStats';
	}
}
